import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConfirmationService, MessageService} from "primeng/api";
import {Calendar} from "primeng/calendar";
import {FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {LostFoundService} from "@app/_components/lost-found/lost-found.service";
import {AlertService, AuthenticationService, ConstantService, UserService} from "@app/_services";
import {Location} from "@angular/common";
import {ReservationService} from "@app/_components/reservation";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {first} from "rxjs/operators";
import * as moment from "moment";
import {WorkOrderComponent} from "@app/_components/reservation/components/reservation/work-order/work-order.component";
import {WorkOrder} from "@app/_components/reservation/components/reservation/work-order/work-order";
import {AdditionalPaymentComponent} from "@app/_components/reservation/components/reservation/additional-payment/additional-payment.component";
import { OwnerStmtExpComponent } from '@app/_components/owner-stmt-exp/owner-stmt-exp/owner-stmt-exp.component';
import { OwnerStmtExp } from '@app/_components/owner-stmt-exp/owner-stmt-exp';
import { ExpenseComponent } from '@app/_components/expense/expense/expense.component';
import { Expense } from '@app/_components/expense/expense';
import { ExpenseService } from '@app/_components/expense/expense.service';
import { ReservationLedgerListComponent } from '@app/_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component';

const numberFormatter = new Intl.NumberFormat('en-US',{
  maximumFractionDigits: 2
});

@Component({
    selector: 'app-statement-detail',
    templateUrl: './statement-detail.component.html',
    styleUrls: ['./statement-detail.component.css'],
    providers: [
        MessageService,
        ConfirmationService,
    ],
    standalone: false
})
export class StatementDetailComponent implements OnInit {

  @ViewChild('checkInDateCal') public checkInDateCalender: Calendar;
  @ViewChild('checkOutDateCal') public checkOutDateCalender: Calendar;

  updatedCheckInDate: Date;
  checkOutDateBasedOnCheckinDate: Date;
  isDateLessThanCheckinDate = false;
  isDisplayClearDates = false;
  minDate: Date;
  maxDate: Date;

  // form
  formLoading = false;

  // nav
  tabIndex: number;
  numAdults: any[];
  workOrders: any;
  lostFounds: any;

  // forms
  form1: UntypedFormGroup;
  form2: UntypedFormGroup;
  formAlert: String;
  formTitle: String;
  openingReservation: { [key: number]: boolean } = {};

  @Input() reservation: any;
  @Input() ownerStmtExp: any;
  @Input() type: any;
  @Input() paymentSources: any;
  @Input() reservationCount: any;
  @Input() reservationIndex: any;
  @Input() shortTermRentalId: any;
  @Output() getReservations = new EventEmitter<any>();
  @Output() refreshOrder = new EventEmitter<any>();
  @Output() reGenerateOrder = new EventEmitter<any>();
  referralSources: any[];
  payEnum: any[];
  reservationStatuses: any[]=[];
  orderStatuses: any[];
  hours: any[];
  minutes: any[];
  amPm: any[];
  airlines: any[];
  countries: any;
  states: any;
  reservationId: any;
  travelOcassions: any;
  cardExpiryMonths: any[];
  cardExpiryYears: any[];
  paymentTypes: any[];
  keyServiceCheckIn: any[];
  orderDetails: any[];
  totalAmounts: number;
  totalTaxes: number;
  grandTotals: number;
  salesManList: any[];
  visible = false;
  isGuestAgreeForCreditCard = false;
  disabledBookReservationButton = false;
  showPaymentSuccess = false;

  cardExpirationMonthMessage: string = "Expiration cannot be in the past";
  travelInsuranceMsg: string = "Travel insurance selection is required";
  guestContractApproveMsg: string = "Acknowledgement is required. Questions? Call (800) 768-6994";
  firstNameMsg: string = "Full name is required";
  lastNameMsg: string = "Last name is required";
  emailAddressMsg: string = "Email address is required";
  validEmailAddressMsg: string = "Valid email is required";
  mobilePhoneMsg: string = "Mobile number is required";
  adrStreetMsg: string = "Address is required";
  adrCitytMsg: string = "City is required";
  adrStateMsg: string = "State or Province is required";
  adrPostalCodeMsg: string = "Postal Code is required";
  adrCountryMsg: string = "Country is required";
  cardHolderNameMsg: string = "Cardholder name is required";
  paymentAddressMsg: string = "Address is required";
  paymentCityMsg: string = "City is required";
  paymentStateMsg: string = "State is required";
  paymentPostalMsg: string = "Postal Code is required";
  paymentProcessAmountMsg: string = "Payment amount is required";
  expirationMonthMsg: string = "Month is required";
  expirationYearMsg: string = "Year is required";
  creditCardNumberMsg: string = "Card number is required";
  cvvCodeMsg: string = "CCV code is required";
  year: number;
  years: any[]=[];
  paymentCreditCardRequests: any[];
  isLoadData = false;
  housekeepingTypes: any[];
  workOrderStatuses: any[];
  childrens: any[];
  checkInMinDate: Date;
  checkOutMinDate: Date;
  checkInMaxDate: Date;
  checkOutMaxDate: Date;
  colorName: string;
  location: any;

  constructor(
    private lostFoundService: LostFoundService,
    public alertService: AlertService,
    private location1: Location,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private reservationService: ReservationService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private constantService: ConstantService,
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private expenseService: ExpenseService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute) {
    this.numAdults = this.reservationService.numAdults;
    this.childrens = this.reservationService.children;
    this.referralSources = this.reservationService.referralSources;
    this.reservationStatuses = this.reservationService.reservationStatuses;
    this.payEnum = this.reservationService.payEnum;
    this.paymentCreditCardRequests = this.reservationService.paymentCreditCardRequests;
    this.orderStatuses = this.reservationService.orderStatuses;
    this.hours = this.reservationService.hours;
    this.minutes = this.reservationService.minutes;
    this.amPm = this.reservationService.amPm;
    this.airlines = this.reservationService.airlines;
    this.countries = this.constantService.countries;
    this.states = this.constantService.states;
    this.travelOcassions = this.reservationService.travelOcassions;
    this.cardExpiryMonths = this.reservationService.cardExpiryMonths;
    this.cardExpiryYears = this.reservationService.cardExpiryYears;
    this.paymentTypes = this.reservationService.paymentTypes;
    this.keyServiceCheckIn = this.reservationService.keyServiceCheckIn;
    this.salesManList = this.reservationService.salesManList;
    this.housekeepingTypes = this.reservationService.housekeepingTypes;
    this.workOrderStatuses = this.reservationService.workOrderStatuses;
    
    // Initialize form1 and form2 as empty FormGroups to prevent template binding errors
    this.form1 = this.formBuilder.group({});
    this.form2 = this.formBuilder.group({});
  }

  adults = [
    { name: 'Adults', value: "" },
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4', value: 4 },
    { name: '5', value: 5 },
    { name: '6', value: 6 },
    { name: '7', value: 7 },
    { name: '8', value: 8 },
    { name: '9', value: 9 },
    { name: '10', value: 10 },
    { name: '11', value: 11 },
    { name: '12', value: 12 },
    { name: '13', value: 13 },
    { name: '14', value: 14 },
    { name: '15', value: 15 },
    { name: '16', value: 16 },
    { name: '17', value: 17 },
    { name: '18', value: 18 },
    { name: '19', value: 19 },
    { name: '20', value: 20 },
  ];

  children = [
    { name: 'Children', value: "" },
    { name: '0', value: 0 },
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4', value: 4 },
    { name: '5', value: 5 },
    { name: '6', value: 6 },
    { name: '7', value: 7 },
    { name: '8', value: 8 },
    { name: '9', value: 9 },
    { name: '10', value: 10 },
    { name: '11', value: 11 },
    { name: '12', value: 12 },
    { name: '13', value: 13 },
    { name: '14', value: 14 },
    { name: '15', value: 15 },
    { name: '16', value: 16 },
    { name: '17', value: 17 },
    { name: '18', value: 18 },
    { name: '19', value: 19 },
    { name: '20', value: 20 },
  ];

  months = [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' },
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' },
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' },
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' }
  ];

  validationMessages = {
    emailAddress: [],
    status:[],
    referralSourceId: [],
    creditSaleToUserId:[],
    creditSaleToUser2Id:[],
    salesTax:[],
    tax:[],
    premium:[],
    reservationStatus:[],
    holdExpirationDate:[],
    numAdults:[],
    numChildren:[],
    primaryMobilePhone:[],
    specialRequests:[],
    airportArrivalDate:[],
    airportDepartureDate:[],
    arrivalHour1:[],
    arrivalMinute1:[],
    arrivalAmPm1:[],
    arrivingAirlineName:[],
    arrivingAirlineFlightNum:[],
    arrivalHour2:[],
    arrivalMinute2:[],
    arrivalAmPm2:[],
    departingAirlineName:[],
    departingAirlineFlightNum:[],
    propertyArrivalHour1:[],
    propertyArrivalMinute1:[],
    propertyArrivalAmPm1:[],
    propertyArrivalHour2:[],
    propertyArrivalMinute2:[],
    propertyArrivalAmPm2:[],
    checkOutDate:[],
    checkInDate:[],
    guestNotes:[],
    opsNotes:[],
    lostFoundId:[],
    keyServiceType:[],
    emergencyContactNotes: [],
    travelOccasionNotes:[],
    travelOccasion:[],
    earlyCheckinDate:[],
    lateCheckoutDate:[],
    codeFrontDoor:[],
    codeGarage:[],
    towelCode:[],
    codeGate:[],
    codeHoaGate:[],
    rentalCarBudget:[],
    rentalCarAvis:[],
    codePool:[],
    codeRecreation:[],
    ruReservationId: [],


    firstName: [{ type: 'required', message: 'Required' }],
    lastName: [{ type: 'required', message: 'Required' }],
    title: [''],
    mobilePhone: [{ type: 'required', message: 'Required' }],
    adrStreet: [{ type: 'required', message: 'Required' }],
    adrCity: [{ type: 'required', message: 'Required' }],
    adrState: [{ type: 'required', message: 'Required' }],
    adrPostalCode: [{ type: 'required', message: 'Required' }],
    adrCountry: [{ type: 'required', message: 'Required' }],
    adrPhone: [{ type: 'required', message: 'Required' }],

    billingName:[{ type: 'required', message: 'Required' }],
    billingStreetAddress:[{ type: 'required', message: 'Required' }],
    billingCity:[{ type: 'required', message: 'Required' }],
    billingState:[{ type: 'required', message: 'Required' }],
    billingPostalCode:[{ type: 'required', message: 'Required' }],
    billingCountry:[{ type: 'required', message: 'Required' }],
    creditCardNumber:[{ type: 'required', message: 'Required' }],
    creditCardExpirationMonth:[{ type: 'required', message: 'Required' }],
    creditCardExpirationYear:[{ type: 'required', message: 'Required' }],
    creditCardSecurityCode:[{ type: 'required', message: 'Required' }],
    paymentType:[],
    achBankName:[],
    achBankAccountNumber:[],
    achRoutingNumber:[],
    achCheckNumber:[],
    achMicrData:[],
    achBranchSortCode:[],

  };

  validationMessages1 = {
    city: [
      { type: 'required', message: this.paymentCityMsg }],
    stateOrProvince: [
      { type: 'required', message: this.paymentStateMsg }],
    postalCode: [
      { type: 'required', message: this.paymentPostalMsg }],
    paymentAmount: [
      { type: 'required', message: this.paymentProcessAmountMsg }],
    country: [
      { type: 'required', message: 'Country is required.' }],
    cardName: [
      { type: 'required', message: this.cardHolderNameMsg }],
    cardExpirationMonth: [
      { type: 'required', message: this.expirationMonthMsg }],
    cardExpirationYear: [
      { type: 'required', message: this.expirationYearMsg }],
    cardNumber: [
      { type: 'required', message: this.creditCardNumberMsg },
      { type: 'maxlength', message: '19 characters maximum' },
      { type: 'minlength', message: '15 characters minimum' }],
    cardSecurityCode: [
      { type: 'required', message: this.cvvCodeMsg },
      { type: 'maxlength', message: '3 characters maximum' },
      { type: 'minlength', message: '4 characters minimum' }],
    cardType: [],
    signName: [
      { type: 'required', message: 'Enter firstname and lastname is required.' }],
    signEmail: [
      { type: 'required', message: 'Enter email address.' }],
    iAgree: [{ type: 'required', message: "required" }],
    paymentSourceId:[],
    paymentCreditCardRequestedTransactionType:[]
  };

  ngOnInit(): void {
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let day = today.getDate();
    this.updatedCheckInDate = today;
    this.minDate = new Date();
    this.maxDate = new Date(year + 3, month, day);
    // this.formBuild();
    this.year = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.years.push({ name: this.year.toString(), value: this.year.toString() });
      this.year = this.year + 1;
    }
    // resolver data
    if(this.reservation == null && this.reservation == undefined){
      this.activatedRoute.params.subscribe(params =>
      {
        this.reservationId = params.reservationId; // (+) converts string 'id' to a number
      });
      if(this.reservationId != null && this.reservationId != undefined){
       // this.findReservationById();
      }else{
       // this.formBuild();
      }
    }else{
      this.reservationId = this.reservation?.reservationId;
      if(this.reservationId != null && this.reservationId != undefined){
        this.findReservationById();
      }
    }
    console.log("this.reservation : "+JSON.stringify(this.reservation))
  }

  // book reservation form builder
  // formBuildForCreditCard() {
  // 	this.form2 = this.formBuilder.group({
  // 		//passed from quote
  // 		reservationId: [this.reservation?.reservationId],
  // 		orderId: [this.reservation?.order?.orderId],

  // 		paymentSource: this.formBuilder.group({
  // 			cardName: [this.reservation?.guestProfile?.firstName+" "+this.reservation?.guestProfile?.lastName, Validators.required],
  // 			cardExpirationMonth: ['', Validators.required],
  // 			cardExpirationYear: ['', Validators.required],
  // 			cardNumber: ['', Validators.required],
  // 			cardSecurityCode: new FormControl('', [Validators.required]),
  // 			cardType: [],
  // 			addressLine1: [],
  // 			city: [],
  // 			stateOrProvince: [],
  // 			postalCode: ['', Validators.required],
  // 			paymentAmount: [this.formatNumber(this.reservation?.invoice?.totalOutstandingBalance), Validators.required],
  // 			country: ['US'],
  // 			paymentType: ['CR'],
  // 			iAgree: [''],
  // 			paymentSourceId: [],
  // 			paymentCreditCardRequestedTransactionType:[]
  // 		}),
  // 		contract: this.formBuilder.group({
  // 			signName: [''],
  // 			signEmail: [''],
  // 			signBase64: [],
  // 		}),
  // 	});
  // }

  formBuild() {
    this.form1 = this.formBuilder.group({
      emailAddress: [],
      status:[],
      referralSourceId: [],
      creditSaleToUserId:[],
      creditSaleToUser2Id:[],
      salesTax:[],
      tax:[],
      premium:[],
      reservationStatus:[],
      holdExpirationDate:[],
      numAdults:[],
      numChildren:[],
      primaryMobilePhone:[],
      specialRequests:[],
      airportArrivalDate:[],
      airportDepartureDate:[],
      arrivalHour1:[],
      arrivalMinute1:[],
      arrivalAmPm1:[],
      arrivingAirlineName:[],
      arrivingAirlineFlightNum:[],
      arrivalHour2:[],
      arrivalMinute2:[],
      arrivalAmPm2:[],
      departingAirlineName:[],
      departingAirlineFlightNum:[],
      propertyArrivalHour1:[],
      propertyArrivalMinute1:[],
      propertyArrivalAmPm1:[],
      propertyArrivalHour2:[],
      propertyArrivalMinute2:[],
      propertyArrivalAmPm2:[],
      checkOutDate:[],
      checkInDate:[],
      specialArrivalHour:[],
      specialArrivalMinute:[],
      specialArrivalAmPm:[],
      specialDepartingHour:[],
      specialDepartingMinute:[],
      specialDepartingAmPm:[],
      guestNotes:[],
      opsNotes:[],
      lostFoundId:[],
      keyServiceType:[],
      codeFrontDoor:[],
      codeGarage:[],
      towelCode:[],
      codeGate:[],
      codeHoaGate:[],
      rentalCarBudget:[],
      rentalCarAvis:[],
      codePool:[],
      codeRecreation:[],
      earlyCheckinDate:[],
      lateCheckoutDate:[],
      ruReservationId: [],

      guestProfile: this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        title: [''],
        emailAddress: ['', [Validators.required, Validators.email]],
        mobilePhone: [],
        adrPhone: [''],
        adrStreet: [],
        adrCity: [],
        adrState: [],
        adrPostalCode: [],
        adrCountry: ['US'],
        emergencyContactNotes: [],
        travelOccasionNotes:[],
        travelOccasion:[],
        primaryMobilePhone:[],
        specialRequests:[],
        guestCompanions: new UntypedFormArray([]),
      }),

      paymentSourceDeposit: this.formBuilder.group({
        billingName:[],
        billingStreetAddress:[],
        billingCity:[],
        billingState:[],
        billingPostalCode:[],
        billingCountry:[],
        creditCardNumber:[],
        creditCardExpirationMonth:[],
        creditCardExpirationYear:[],
        creditCardSecurityCode:[''],
        paymentType:[],
        achBankName:[],
        achBankAccountNumber:[],
        achRoutingNumber:[],
        achCheckNumber:[],
        achMicrData:[],
        achBranchSortCode:[],

      }),

      paymentSourceFunding: this.formBuilder.group({
        billingName:[],
        billingStreetAddress:[],
        billingCity:[],
        billingState:[],
        billingPostalCode:[],
        billingCountry:[],
        creditCardNumber:[],
        creditCardExpirationMonth:[],
        creditCardExpirationYear:[],
        creditCardSecurityCode:[''],
        paymentType:[],
        achBankName:[],
        achBankAccountNumber:[],
        achRoutingNumber:[],
        achCheckNumber:[],
        achMicrData:[],
        achBranchSortCode:[],

      }),
    });
  }

  // not used since we are bringing the res in on a resolver
  findReservationById() {
   /* this.formLoading = true;
    this.reservationService.findById(this.reservationId)
      .pipe(first())
      .subscribe(
        res => {
          console.log('findReservationById: ' + JSON.stringify(res));
          this.reservation = res.data.reservation;
          this.getLocationByLocationId();
          if(this.reservation?.reservationStatus == "QO"){
            this.colorName = 'lightgreen';
          }
          if(this.reservation?.reservationStatus == "QH"){
            this.colorName = 'yellow';
          }
          if(this.reservation?.reservationStatus == "QE"){
            this.colorName = '#ec5300';
          }
          if(this.reservation?.reservationStatus == "OP"){
            this.colorName = 'lightgrey';
          }
          if(this.reservation?.reservationStatus == "OC"){
            this.colorName = '#FF7F7F';
          }
          if(this.reservation?.reservationStatus == "PP"){
            this.colorName = '#ffb09c';
          }
          if(this.reservation?.reservationStatus == "OX"){
            this.colorName = 'darkred';
          }
          if(this.reservation?.reservationStatus == "NA"){
            this.colorName = 'darkgray';
          }
          if(this.reservation?.reservationStatus == "OO"){
            this.colorName = 'hotpink';
          }
          if(this.reservation?.reservationStatus == "OG"){
            this.colorName = 'lightpink';
          }
          this.reservation.reservationDirty = false;

          this.checkInMinDate = moment(this.reservation?.checkInDate).toDate();
          this.checkInMaxDate = new Date(this.checkInMinDate.getFullYear() + 3, this.checkInMinDate.getMonth(), this.checkInMinDate.getDate());

          this.checkOutMinDate = moment(this.reservation?.checkOutDate).toDate();
          this.checkOutMaxDate = new Date(this.checkOutMinDate.getFullYear() + 3, this.checkOutMinDate.getMonth(), this.checkOutMinDate.getDate());

          this.getReservations.emit(this.reservation);
          this.totalAmounts = this.totalAmount();
          this.totalTaxes = this.totalTax();
          this.grandTotals = this.grandTotal();
          if(this.reservation?.reservationStatus === 'OP'){
            this.mapReservation(this.reservation);
          }else{
            this.mapReservationWithRemoveValidationOfPaymentSource(this.reservation);
          }

        },
        err => {
          console.log('error In findReservationById is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, sticky: true });
        },
        () => { this.formLoading = false; });*/
  }
  getLocationByLocationId() {
    this.reservationService.search(this.reservation?.shortTermRental?.propertyCode,this.reservation?.shortTermRental?.locationId)
      .then(value => {

        console.log('findReservationById: ' + JSON.stringify(value));
        this.location = value.search[0];
      });
  }

  mapReservation(reservation: any) {
    this.form1 = this.formBuilder.group({
      status: reservation?.order?.status,
      referralSourceId: reservation?.order?.referralSourceId,
      ruReservationId: reservation?.ruReservationId,

      //=============================
      creditSaleToUserId: reservation?.reservationist?.userId,
      creditSaleToUser2Id: reservation?.reservationist2?.userId,
      salesTax: [],
      tax: [],
      //=============================


      premium: reservation?.order?.orderInvoice?.ccPremiumPct != null ? reservation?.order?.orderInvoice?.ccPremiumPct : "0.0000%",
      reservationStatus: reservation?.reservationStatus,
      holdExpirationDate: reservation?.holdExpirationDate,
      numAdults: reservation?.numAdults,
      numChildren: reservation?.numChildren,
      airportArrivalDate: reservation?.airportArrivalDate != null ? moment.utc(reservation?.airportArrivalDate).toDate() : null,
      airportDepartureDate: reservation?.airportDepartureDate != null ? moment.utc(reservation?.airportDepartureDate).toDate() : null,

      earlyCheckinDate: reservation?.earlyCheckinDate != null ? moment.utc(reservation?.earlyCheckinDate).toDate() : null,
      lateCheckoutDate: reservation?.lateCheckoutDate != null ? moment.utc(reservation?.lateCheckoutDate).toDate() : null,
      // airportArrivalDate: reservation?.airportArrivalDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportArrivalDate).toDate()) : null,
      // airportDepartureDate: reservation?.airportDepartureDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportDepartureDate).toDate()) : null,

      // earlyCheckinDate: reservation?.earlyCheckinDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.earlyCheckinDate).toDate()) : null,
      // lateCheckoutDate: reservation?.lateCheckoutDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.lateCheckoutDate).toDate()) : null,
      //===============================
      arrivalHour1: [],
      arrivalMinute1: [],
      arrivalAmPm1: [],
      //===================================

      arrivingAirlineName: reservation?.arrivingAirlineName,
      arrivingAirlineFlightNum: reservation?.arrivingAirlineFlightNum,

      //=============================
      arrivalHour2: [],
      arrivalMinute2: [],
      arrivalAmPm2: [],
      //===============================


      departingAirlineName: reservation?.departingAirlineName,
      departingAirlineFlightNum: reservation?.departingAirlineFlightNum,

      //==============================
      propertyArrivalHour1: [],
      propertyArrivalMinute1: [],
      propertyArrivalAmPm1: [],
      propertyArrivalHour2: [],
      propertyArrivalMinute2: [],
      propertyArrivalAmPm2: [],
      //=======================================

      checkOutDate: moment(reservation?.checkOutDate).toDate(),
      checkInDate: moment(reservation?.checkInDate).toDate(),

      //=====================================
      specialArrivalHour: [],
      specialArrivalMinute: [],
      specialArrivalAmPm: [],
      specialDepartingHour: [],
      specialDepartingMinute: [],
      specialDepartingAmPm: [],
      //====================================

      guestNotes: reservation?.guestNotes,
      opsNotes: reservation?.opsNotes,
      lostFoundId: [],
      keyServiceType: reservation?.keyServiceType,
      codeFrontDoor: reservation?.codeFrontDoor,
      codeGarage: reservation?.codeGarage,
      towelCode: reservation?.towelCode,
      codeGate: reservation?.codeGate,
      codeHoaGate: reservation?.codeHoaGate,
      rentalCarBudget: reservation?.rentalCarBudget,
      rentalCarAvis: reservation?.rentalCarAvis,
      codePool: reservation?.codePool,
      codeRecreation: reservation?.codeRecreation,
      primaryMobilePhone: reservation?.primaryMobilePhone,
      specialRequests: reservation?.specialRequests,


      guestProfile: this.formBuilder.group({
        guestProfileId:[reservation?.guestProfile?.guestProfileId],
        primaryMobilePhone:reservation?.primaryMobilePhone,
        firstName: [reservation?.guestProfile?.firstName, Validators.required],
        lastName: [reservation?.guestProfile?.lastName, Validators.required],
        title: reservation?.guestProfile?.title,
        emailAddress: [reservation?.guestProfile?.emailAddress, Validators.required],
        mobilePhone: [reservation?.guestProfile?.mobilePhone],
        adrPhone: reservation?.guestProfile?.adrPhone,
        adrStreet: reservation?.guestProfile?.adrStreet,
        adrCity: reservation?.guestProfile?.adrCity,
        adrState: reservation?.guestProfile?.adrState,
        adrPostalCode: reservation?.guestProfile?.adrPostalCode,
        adrCountry: reservation?.guestProfile?.adrCountry != null ? reservation?.guestProfile?.adrCountry : 'US',
        emergencyContactNotes: reservation?.guestProfile?.emergencyContactNotes,
        travelOccasionNotes: reservation?.guestProfile?.travelOccasionNotes,
        travelOccasion: reservation?.guestProfile?.travelOccasion,
        guestCompanions: new UntypedFormArray([]),
      }),

      paymentSourceDeposit: this.formBuilder.group({

        billingName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingName,
        billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingStreetAddress,
        billingCity: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingCity,
        billingState: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingState,
        billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingPostalCode,
        billingCountry: 'US',
        creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardNumber,
        creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationMonth,
        creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationYear,
        creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardSecurityCode,
        paymentType: reservation?.order?.orderInvoice?.paymentSourceDeposit?.paymentType,
        achBankName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankName,
        achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankAccountNumber,
        achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achRoutingNumber,
        achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achCheckNumber,
        achMicrData: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achMicrData,
        achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBranchSortCode,

      }),

      paymentSourceFunding: this.formBuilder.group({

        billingName: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingName,
        billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingStreetAddress,
        billingCity: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingCity,
        billingState: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingState,
        billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingPostalCode,
        billingCountry: 'US',
        creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardNumber,
        creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationMonth,
        creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationYear,
        creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardSecurityCode,
        paymentType: reservation?.order?.orderInvoice?.paymentSourceFunding?.paymentType,
        achBankName: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankName,
        achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankAccountNumber,
        achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achRoutingNumber,
        achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achCheckNumber,
        achMicrData: reservation?.order?.orderInvoice?.paymentSourceFunding?.achMicrData,
        achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBranchSortCode,

      }),
    });
    if(this.reservation?.guestProfile?.guestCompanions.length > 0){
      this.reservation?.guestProfile?.guestCompanions.forEach((campanion: any) => {
        this.guestCompanions.push(this.mapCompanion(campanion));
      });
    }
    // if(this.reservation?.guestProfile?.guestCompanions.length == 0 || this.reservation?.guestProfile?.guestCompanions.length == null || this.reservation?.guestProfile?.guestCompanions.length == undefined){
    // 	for (let i = 1; i < (this.reservation?.numAdults + this.reservation?.numChildren); i++) {
    // 		if (this.guestCompanions.length < i) {
    // 			this.guestCompanions.push(this.newCompanion());
    // 		}
    // 	}
    // }

    this.isLoadData = true;
  }

  formatNumber(number: any): any{
    if (number) {
      return numberFormatter.format(number);
    }
    else {
      '';
    }
  }

  mapReservationWithRemoveValidationOfPaymentSource(reservation: any) {
    this.form1 = this.formBuilder.group({
      status: reservation?.order?.status,
      referralSourceId: reservation?.order?.referralSourceId,
      ruReservationId: reservation?.ruReservationId,

      //=============================
      creditSaleToUserId: reservation?.reservationist?.userId,
      creditSaleToUser2Id: reservation?.reservationist2?.userId,
      salesTax: [],
      tax: [],
      //=============================


      premium: reservation?.order?.orderInvoice?.ccPremiumPct != null ? reservation?.order?.orderInvoice?.ccPremiumPct : "0.0000%",
      reservationStatus: reservation?.reservationStatus,
      holdExpirationDate: reservation?.holdExpirationDate,
      numAdults: reservation?.numAdults,
      numChildren: reservation?.numChildren,
      airportArrivalDate: reservation?.airportArrivalDate != null ? moment.utc(reservation?.airportArrivalDate).toDate() : null,
      airportDepartureDate: reservation?.airportDepartureDate != null ? moment.utc(reservation?.airportDepartureDate).toDate() : null,

      earlyCheckinDate: reservation?.earlyCheckinDate != null ? moment.utc(reservation?.earlyCheckinDate).toDate() : null,
      lateCheckoutDate: reservation?.lateCheckoutDate != null ? moment.utc(reservation?.lateCheckoutDate).toDate() : null,

      // airportArrivalDate: reservation?.airportArrivalDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportArrivalDate).toDate()) : null,
      //   airportDepartureDate: reservation?.airportDepartureDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportDepartureDate).toDate()) : null,

      //   earlyCheckinDate: reservation?.earlyCheckinDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.earlyCheckinDate).toDate()) : null,
      //   lateCheckoutDate: reservation?.lateCheckoutDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.lateCheckoutDate).toDate()) : null,

      //===============================
      // arrivalHour1: [],
      // arrivalMinute1: [],
      // arrivalAmPm1: [],
      //===================================

      arrivingAirlineName: reservation?.arrivingAirlineName,
      arrivingAirlineFlightNum: reservation?.arrivingAirlineFlightNum,

      //=============================
      // arrivalHour2: [],
      // arrivalMinute2: [],
      // arrivalAmPm2: [],
      //===============================


      departingAirlineName: reservation?.departingAirlineName,
      departingAirlineFlightNum: reservation?.departingAirlineFlightNum,

      //==============================
      propertyArrivalHour1: [],
      propertyArrivalMinute1: [],
      propertyArrivalAmPm1: [],
      propertyArrivalHour2: [],
      propertyArrivalMinute2: [],
      propertyArrivalAmPm2: [],
      //=======================================

      checkOutDate: moment(reservation?.checkOutDate).toDate(),
      checkInDate: moment(reservation?.checkInDate).toDate(),

      //=====================================
      // specialArrivalHour: [],
      // specialArrivalMinute: [],
      // specialArrivalAmPm: [],
      // specialDepartingHour: [],
      // specialDepartingMinute: [],
      // specialDepartingAmPm: [],
      //====================================

      guestNotes: reservation?.guestNotes,
      opsNotes: reservation?.opsNotes,
      lostFoundId: [],
      keyServiceType: reservation?.keyServiceType,
      codeFrontDoor: reservation?.codeFrontDoor,
      codeGarage: reservation?.codeGarage,
      towelCode: reservation?.towelCode,
      codeGate: reservation?.codeGate,
      codeHoaGate: reservation?.codeHoaGate,
      rentalCarBudget: reservation?.rentalCarBudget,
      rentalCarAvis: reservation?.rentalCarAvis,
      codePool: reservation?.codePool,
      codeRecreation: reservation?.codeRecreation,
      primaryMobilePhone:reservation?.primaryMobilePhone,
      specialRequests: reservation?.specialRequests,

      guestProfile: this.formBuilder.group({
        guestProfileId:[reservation?.guestProfile?.guestProfileId],
        primaryMobilePhone:reservation?.primaryMobilePhone,
        firstName: [reservation?.guestProfile?.firstName, Validators.required],
        lastName: [reservation?.guestProfile?.lastName, Validators.required],
        title: reservation?.guestProfile?.title,
        emailAddress: [reservation?.guestProfile?.emailAddress, Validators.required],
        mobilePhone: [reservation?.guestProfile?.mobilePhone],
        adrPhone: reservation?.guestProfile?.adrPhone,
        adrStreet: reservation?.guestProfile?.adrStreet,
        adrCity: reservation?.guestProfile?.adrCity,
        adrState: reservation?.guestProfile?.adrState,
        adrPostalCode: reservation?.guestProfile?.adrPostalCode,
        adrCountry: reservation?.guestProfile?.adrCountry != null ? reservation?.guestProfile?.adrCountry : 'US',
        emergencyContactNotes: reservation?.guestProfile?.emergencyContactNotes,
        travelOccasionNotes: reservation?.guestProfile?.travelOccasionNotes,
        travelOccasion: reservation?.guestProfile?.travelOccasion,
        guestCompanions: new UntypedFormArray([]),
      }),

      paymentSourceDeposit: this.formBuilder.group({

        billingName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingName,
        billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingStreetAddress,
        billingCity: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingCity,
        billingState: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingState,
        billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingPostalCode,
        billingCountry: ['US'],
        creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardNumber,
        creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationMonth,
        creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationYear,
        creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardSecurityCode,
        paymentType: reservation?.order?.orderInvoice?.paymentSourceDeposit?.paymentType,
        achBankName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankName,
        achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankAccountNumber,
        achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achRoutingNumber,
        achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achCheckNumber,
        achMicrData: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achMicrData,
        achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBranchSortCode,

      }),

      paymentSourceFunding: this.formBuilder.group({

        billingName: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingName,
        billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingStreetAddress,
        billingCity: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingCity,
        billingState: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingState,
        billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingPostalCode,
        billingCountry: ['US'],
        creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardNumber,
        creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationMonth,
        creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationYear,
        creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardSecurityCode,
        paymentType: reservation?.order?.orderInvoice?.paymentSourceFunding?.paymentType,
        achBankName: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankName,
        achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankAccountNumber,
        achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achRoutingNumber,
        achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achCheckNumber,
        achMicrData: reservation?.order?.orderInvoice?.paymentSourceFunding?.achMicrData,
        achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBranchSortCode,

      }),
    });
    if(this.reservation?.guestProfile?.guestCompanions.length > 0){
      this.reservation?.guestProfile?.guestCompanions.forEach((campanion: any) => {
        this.guestCompanions.push(this.mapCompanion(campanion));
      });
    }
    // if(this.reservation?.guestProfile?.guestCompanions.length == 0 || this.reservation?.guestProfile?.guestCompanions.length == null || this.reservation?.guestProfile?.guestCompanions.length == undefined){
    // 	for (let i = 1; i < (this.reservation?.numAdults + this.reservation?.numChildren); i++) {
    // 		if (this.guestCompanions.length < i) {
    // 			this.guestCompanions.push(this.newCompanion());
    // 		}
    // 	}
    // }
    this.isLoadData = true;
  }

  onOpenFormWorkOrder() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "40vw";
    dialogConfig.width = "30vw";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Word Order Detail',
      reservation: this.reservation
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(WorkOrderComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.addWorkOrderCB(data);
        this.findReservationById();
        // close the dialogBox
        dialogRef.close();
      });
  }

  onOpenForEditWorkOrder(workOrder: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "40vw";
    dialogConfig.width = "30vw";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Edit Word Order Detail',
      reservation: this.reservation,
      workOrder: workOrder
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(WorkOrderComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.findReservationById();
        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.addWorkOrderCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }

  addWorkOrderCB(workOrder: WorkOrder) {
    console.log('Adding OrderDetail: ' + JSON.stringify(workOrder));
    // if we don't have a orderDetails array yet...
    if (!this.workOrders) {
      this.workOrders = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.workOrders.unshift(workOrder);

    // no idea what this is but it is required to update the array
    this.workOrders = [...this.workOrders];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'WorkOrder ' + workOrder.workOrderId + ' Added', life: 1000 });
  }

  gotoReservation() {
    this.location1.go('/reservations');
    this.router.navigate(['reservations']);
  }

  handleChange(e) {
    console.log("index : "+e.index);
    var index = e.index;
    if(index == 3){
      this.getLostFound();
    }
  }

  openReservation(reservation: any, event: any) {
    let reservationId = reservation?.reservationId;
    event.stopPropagation();
    this.openingReservation[reservationId] = true;
    this.reservationService.getOrderIdByReservationId(reservationId).pipe(first()).subscribe(
      (res: any) => {
        console.log('Order ID: ' + JSON.stringify(res));
        window.open(`https://admin.kbmhawaii.com/order/${res.data.orderId}`, '_blank');
        this.openingReservation[reservationId] = false;
      },
      (err: any) => {
        console.log('Error fetching order ID: ' + JSON.stringify(err));
        this.openingReservation[reservationId] = false;
      }
    );
  }

  /*********
   * Lazy Load All Data
   *
   */
  getLostFound() {
    this.lostFoundService.findByReservationId(this.reservation.reservationId)
      .pipe(first())
      .subscribe(
        res => {
          console.log('findReservationById: ' + JSON.stringify(res));
          this.lostFounds = res.data.lostFounds;
        },
        err => {
          console.log('error In findReservationById is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, sticky: true });
        },
        () => { this.formLoading = false; });
  }

  sendReviewEmailBeforeCheckout() {
    this.formLoading = true;
    this.reservationService.sendReviewEmailBeforeCheckout(this.reservation)
      .pipe(first())
      .subscribe(
        res => {
          console.log('findReservationById: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email send successfully', life: 1000 });
        },
        err => {
          // Do NOT reset formLoading on error — a 504 means the email may have been sent.
          // Keep button disabled to prevent a duplicate email from being triggered.
          console.log('sendReviewEmailBeforeCheckout FAIL: ' + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email send may have completed. Please refresh before retrying.', sticky: true });
        },
        () => { this.formLoading = false; });
  }

  sendReviewEmailAfterCheckout() {
    this.formLoading = true;
    this.reservationService.sendReviewEmailAfterCheckout(this.reservation)
      .pipe(first())
      .subscribe(
        res => {
          console.log('findReservationById: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email send successfully', life: 1000 });
        },
        err => {
          // Do NOT reset formLoading on error — a 504 means the email may have been sent.
          // Keep button disabled to prevent a duplicate email from being triggered.
          console.log('sendReviewEmailAfterCheckout FAIL: ' + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email send may have completed. Please refresh before retrying.', sticky: true });
        },
        () => { this.formLoading = false; });
  }

  reservationStatusConfBox(){
    this.confirmationService.confirm({
      message: 'Are you sure you want to change reservation status to "'+this.getReservationStatus(this.form1.value.reservationStatus)+'"? for ReservationId# ' + this.reservationId,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.updateReservationStatusAndAdult();
      },
      reject: () => {
        this.form1.patchValue({
          reservationStatus: this.reservation.reservationStatus
        })
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Status changed canceled.', life: 1000 });
      }
    });
  }

  updateReservation() {
    // stop here if form is invalid
    this.form1.markAllAsTouched();
    if (this.form1.invalid) {
      return;
    }
    // this.formLoading = true;
    this.reservation.order.status = this.form1.value.status;
    this.reservation.order.referralSourceId = this.form1.value.referralSourceId;
    this.reservation.ruReservationId = this.form1.value.ruReservationId;

    //=============================
    // creditSaleToUserId: [],
    // creditSaleToUser2Id: [],
    // salesTax: [],
    // tax: [] = this.form1.value.
    //=============================
    if(this.form1.value.premium === "0.0000%"){
      this.reservation.order.orderInvoice.ccPremiumPct = this.reservation.order.orderInvoice.ccPremiumPct;
    }else{
      this.reservation.order.orderInvoice.ccPremiumPct = this.form1.value.premium;
    }
    this.reservation.reservationStatus = this.form1.value.reservationStatus;
    this.reservation.numAdults = this.form1.value.numAdults;
    this.reservation.numChildren = this.form1.value.numChildren;
    this.reservation.airportArrivalDate = this.form1.value.airportArrivalDate;
    this.reservation.airportDepartureDate = this.form1.value.airportDepartureDate;

    this.reservation.earlyCheckinDate = this.form1.value.earlyCheckinDate;
    this.reservation.lateCheckoutDate = this.form1.value.lateCheckoutDate;

    //===============================
    // arrivalHour1: [] = this.form1.value.
    // arrivalMinute1: [] = this.form1.value.
    // arrivalAmPm1: [] = this.form1.value.
    //===================================

    this.reservation.arrivingAirlineName = this.form1.value.arrivingAirlineName;
    this.reservation.arrivingAirlineFlightNum = this.form1.value.arrivingAirlineFlightNum;

    //=============================
    // arrivalHour2: [] = this.form1.value.
    // arrivalMinute2: [] = this.form1.value.
    // arrivalAmPm2: [] = this.form1.value.
    //===============================


    this.reservation.departingAirlineName = this.form1.value.departingAirlineName;
    this.reservation.departingAirlineFlightNum = this.form1.value.departingAirlineFlightNum;

    //==============================
    // propertyArrivalHour1: [] = this.form1.value.
    // propertyArrivalMinute1: [] = this.form1.value.
    // propertyArrivalAmPm1: [] = this.form1.value.
    // propertyArrivalHour2: [] = this.form1.value.
    // propertyArrivalMinute2: [] = this.form1.value.
    // propertyArrivalAmPm2: [] = this.form1.value.
    //=======================================

    this.reservation.checkOutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkOutDate));
    this.reservation.checkInDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkInDate));

    //=====================================
    // specialArrivalHour: [] = this.form1.value.
    // specialArrivalMinute: [] = this.form1.value.
    // specialArrivalAmPm: [] = this.form1.value.
    // specialDepartingHour: [] = this.form1.value.
    // specialDepartingMinute: [] = this.form1.value.
    // specialDepartingAmPm: [] = this.form1.value.
    //====================================

    this.reservation.guestNotes = this.form1.value.guestNotes;
    this.reservation.opsNotes = this.form1.value.opsNotes;
    // lostFoundId: [] = this.form1.value.
    this.reservation.keyServiceType = this.form1.value.keyServiceType;
    this.reservation.codeFrontDoor = this.form1.value.codeFrontDoor;
    this.reservation.codeGarage = this.form1.value.codeGarage;
    this.reservation.towelCode = this.form1.value.towelCode,
      this.reservation.codeGate = this.form1.value.codeGate;
    this.reservation.codeHoaGate = this.form1.value.codeHoaGate;
    this.reservation.rentalCarBudget = this.form1.value.rentalCarBudget;
    this.reservation.rentalCarAvis = this.form1.value.rentalCarAvis;
    this.reservation.codePool = this.form1.value.codePool;
    this.reservation.codeRecreation = this.form1.value.codeRecreation;
    this.reservation.primaryMobilePhone = this.form1.value.guestProfile.primaryMobilePhone;
    this.reservation.specialRequests = this.form1.value.specialRequests;
    // this.reservation.earlyCheckinDate = this.reservation.earlyCheckinDate;
    // this.reservation.lateCheckoutDate = this.reservation.lateCheckoutDate;

    if(this.reservation.guestProfile != null && this.reservation.guestProfile != undefined){
      this.reservation.guestProfile.firstName = this.form1.value.guestProfile.firstName;
      this.reservation.guestProfile.lastName = this.form1.value.guestProfile.lastName;
      this.reservation.guestProfile.title = this.form1.value.guestProfile.title;
      this.reservation.guestProfile.emailAddress = this.form1.value.guestProfile.emailAddress;
      this.reservation.guestProfile.mobilePhone = this.form1.value.guestProfile.mobilePhone;
      this.reservation.guestProfile.adrPhone = this.form1.value.guestProfile.adrPhone;
      this.reservation.guestProfile.adrStreet = this.form1.value.guestProfile.adrStreet;
      this.reservation.guestProfile.adrCity = this.form1.value.guestProfile.adrCity;
      this.reservation.guestProfile.adrState = this.form1.value.guestProfile.adrState;
      this.reservation.guestProfile.adrPostalCode = this.form1.value.guestProfile.adrPostalCode;
      this.reservation.guestProfile.adrCountry = this.form1.value.guestProfile.adrCountry;
      this.reservation.guestProfile.emergencyContactNotes = this.form1.value.guestProfile.emergencyContactNotes;
      this.reservation.guestProfile.travelOccasionNotes = this.form1.value.guestProfile.travelOccasionNotes;
      this.reservation.guestProfile.travelOccasion = this.form1.value.guestProfile.travelOccasion;
    }
    // if(this.guestCompanions.length > 0){
    this.reservation.guestProfile.guestCompanions =  this.form1.value.guestProfile.guestCompanions;
    // }

    if(this.reservation.order.orderInvoice.paymentSourceDeposit == null || this.reservation.order.orderInvoice.paymentSourceDeposit == undefined){
      const paymentData = {
        billingName: "",
        billingStreetAddress: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: "",
        billingCountry: "",
        creditCardNumber: "",
        creditCardExpirationMonth: "",
        creditCardExpirationYear: "",
        creditCardSecurityCode: "",
        paymentType: "",
        achBankName: "",
        achBankAccountNumber: "",
        achRoutingNumber: "",
        achCheckNumber: "",
        achMicrData: "",
        achBranchSortCode: "",
      }
      this.reservation.order.orderInvoice.paymentSourceDeposit = paymentData;
    }

    this.reservation.order.orderInvoice.paymentSourceDeposit.billingName = this.form1.value.paymentSourceDeposit.billingName;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingStreetAddress = this.form1.value.paymentSourceDeposit.billingStreetAddress;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingCity = this.form1.value.paymentSourceDeposit.billingCity;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingState = this.form1.value.paymentSourceDeposit.billingState;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingPostalCode = this.form1.value.paymentSourceDeposit.billingPostalCode;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingCountry = this.form1.value.paymentSourceDeposit.billingCountry;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardNumber = this.form1.value.paymentSourceDeposit.creditCardNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationMonth = this.form1.value.paymentSourceDeposit.creditCardExpirationMonth;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationYear = this.form1.value.paymentSourceDeposit.creditCardExpirationYear;
    if(this.form1.value.paymentSourceDeposit.creditCardSecurityCode != null && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != undefined && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != ""){
      this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardSecurityCode = this.form1.value.paymentSourceDeposit.creditCardSecurityCode.toString();
    }
    this.reservation.order.orderInvoice.paymentSourceDeposit.paymentType = this.form1.value.paymentSourceDeposit.paymentType;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBankName = this.form1.value.paymentSourceDeposit.achBankName;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBankAccountNumber = this.form1.value.paymentSourceDeposit.achBankAccountNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achRoutingNumber = this.form1.value.paymentSourceDeposit.achRoutingNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achCheckNumber = this.form1.value.paymentSourceDeposit.achCheckNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achMicrData = this.form1.value.paymentSourceDeposit.achMicrData;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBranchSortCode = this.form1.value.paymentSourceDeposit.achBranchSortCode;


    if(this.reservation.order.orderInvoice.paymentSourceFunding == null || this.reservation.order.orderInvoice.paymentSourceFunding == undefined){
      const paymentData = {
        billingName: "",
        billingStreetAddress: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: "",
        billingCountry: "",
        creditCardNumber: "",
        creditCardExpirationMonth: "",
        creditCardExpirationYear: "",
        creditCardSecurityCode: "",
        paymentType: "",
        achBankName: "",
        achBankAccountNumber: "",
        achRoutingNumber: "",
        achCheckNumber: "",
        achMicrData: "",
        achBranchSortCode: "",
      }
      this.reservation.order.orderInvoice.paymentSourceFunding = paymentData;
    }

    this.reservation.order.orderInvoice.paymentSourceFunding.billingName = this.form1.value.paymentSourceFunding.billingName;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingStreetAddress = this.form1.value.paymentSourceFunding.billingStreetAddress;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingCity = this.form1.value.paymentSourceFunding.billingCity;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingState = this.form1.value.paymentSourceFunding.billingState;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingPostalCode = this.form1.value.paymentSourceFunding.billingPostalCode;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingCountry = this.form1.value.paymentSourceFunding.billingCountry;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardNumber = this.form1.value.paymentSourceFunding.creditCardNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationMonth = this.form1.value.paymentSourceFunding.creditCardExpirationMonth;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationYear = this.form1.value.paymentSourceFunding.creditCardExpirationYear;
    if(this.form1.value.paymentSourceFunding.creditCardSecurityCode != null && this.form1.value.paymentSourceFunding.creditCardSecurityCode != undefined && this.form1.value.paymentSourceFunding.creditCardSecurityCode != ""){
      this.reservation.order.orderInvoice.paymentSourceFunding.creditCardSecurityCode = this.form1.value.paymentSourceFunding.creditCardSecurityCode.toString();
    }
    this.reservation.order.orderInvoice.paymentSourceFunding.paymentType = this.form1.value.paymentSourceFunding.paymentType;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBankName = this.form1.value.paymentSourceFunding.achBankName;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBankAccountNumber = this.form1.value.paymentSourceFunding.achBankAccountNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achRoutingNumber = this.form1.value.paymentSourceFunding.achRoutingNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achCheckNumber = this.form1.value.paymentSourceFunding.achCheckNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achMicrData = this.form1.value.paymentSourceFunding.achMicrData;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBranchSortCode = this.form1.value.paymentSourceFunding.achBranchSortCode;


    this.reservation.reservationDirty = true;
    this.getReservations.emit(this.reservation);
    // this.alertService.error('Please enter a title first before entering any other fields.');
    // this.reservationService.updateGuestInfo(this.reservation)
    // 	.pipe(first())
    // 	.subscribe(
    // 		res => {
    // 			console.log('findReservationById: ' + JSON.stringify(res));
    // 			this.alertService.success("Reservation update successfully", true);
    // 			// this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Update reservation successfully', life: 1000 });
    // 			// this.reservation = res.data.reservation;
    // 			// this.findReservationById();
    // 		},
    // 		err => {
    // 			this.alertService.error(err, true);
    // 			console.log('error reservation update: ' + JSON.stringify(err));
    // 			this.formLoading = false;
    // 			// this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update fail: ' + err, sticky: true });
    // 		},
    // 		() => { this.formLoading = false; });
  }

  grandTotal(){
    let total = 0
    if(this.reservation?.order?.orderInvoice?.orderDetails.length > 0){
      this.reservation?.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
        total += orderDetail?.total
      });
    }
    return total;
  }

  totalTax(){
    let total = 0
    if(this.reservation?.order?.orderInvoice?.orderDetails.length > 0){
      this.reservation?.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
        total += orderDetail?.tax
      });
    }
    return total;
  }
  totalAmount(){
    let total = 0;
    if(this.reservation?.order?.orderInvoice?.orderDetails.length > 0){
      this.reservation?.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
        total += orderDetail?.subTotal
      });
    }
    return total;
  }

  /**
   *
   *
   * GUEST COMPANION FORM
   *
   *
   */
  get guestCompanions(): FormArray {
    return this.form1.get('guestProfile')?.get('guestCompanions') as FormArray
  }

  newCompanion(): FormGroup {
    // check testmod is true or false
    // if (this.isTestMode) {
    // 	// if testmode is true at that time set this build form
    // 	return this._formBuilder.group({
    // 		firstName: Math.random().toString(36).substring(2, 7),
    // 		lastName: Math.random().toString(36).substring(2, 7),
    // 		birthDate: new Date(+(new Date()) - Math.floor(Math.random() * 10000000000)),
    // 		ageType: ''
    // 	})
    // }
    // if not testmode at that time set this build form
    if(this.guestCompanions.length < (this.reservation?.numAdults) - 1){
      return this.formBuilder.group({
        firstName: [''],
        lastName: [''],
        birthDate: [''],
        ageType: ['adult'],
        guestCompanionId: [''],
        guestProfileId: [this.reservation?.guestProfile?.guestProfileId]
      })
    }else{
      return this.formBuilder.group({
        firstName: [''],
        lastName: [''],
        birthDate: [''],
        ageType: ['child'],
        guestCompanionId: [''],
        guestProfileId: [this.reservation?.guestProfile?.guestProfileId]
      })
    }
  }

  mapCompanion(campanion: any): FormGroup {
    return this.formBuilder.group({
      firstName: campanion?.firstName,
      lastName: campanion?.lastName,
      birthDate: campanion?.birthDate != null ? moment(campanion?.birthDate).toDate() : "",
      ageType: campanion?.ageType,
      guestCompanionId: campanion?.guestCompanionId,
      guestProfileId: this.reservation?.guestProfile?.guestProfileId
    })
  }

  // this methos use for add companions
  addCompanion() {
    if(this.guestCompanions.length < ((this.reservation?.numAdults + this.reservation?.numChildren) - 1)){
      this.guestCompanions.push(this.newCompanion());
    }
  }

  // use for delete campanion
  deleteCompanion(i: number) {
    this.guestCompanions.removeAt(i);
    this.updateReservation();
  }

  // showDialog() {
  // 	this.form2.reset();
  // 	this.cdr.detectChanges();
  // 	this.visible = true;
  // }

  // makeAdditionalPayment() {
  // 	try {
  // 		// stop here if form is invalid
  // 		this.form2.markAllAsTouched();
  // 		if(this.form2.value.paymentSource.iAgree == "" || this.form2.value.paymentSource.iAgree == null || this.form2.value.paymentSource.iAgree == false || this.form2.value.paymentSource.iAgree == undefined){
  // 			this.isGuestAgreeForCreditCard = true;
  // 			this.disabledBookReservationButton = false;
  // 			return;
  // 		}else{
  // 			this.isGuestAgreeForCreditCard = false;
  // 			// this.form2.value.paymentSource.iAgree == "Yes"
  // 		}
  // 		if (this.form2.invalid) {
  // 			this.disabledBookReservationButton = false;
  // 			return;
  // 		}

  // 		this.formLoading = true;
  // 		// set contract data into form contract
  // 		// this.form1.value.contract.signBase64 = this.signBase64;
  // 		console.log("this.form1.value this.form1.value " + JSON.stringify(this.form2.value));
  // 		const paymentData = {
  // 			"reservationId": this.reservation.reservationId,
  // 			"orderId": this.reservation?.order?.orderId,
  // 			"paymentSource": {
  // 				"firstName": this.reservation?.guestProfile?.firstName,
  // 				"lastName": this.reservation?.guestProfile?.lastName,
  // 				"paymentAmount": this.form2.value?.paymentSource?.paymentAmount.replace(/[\$,]/g, ''),
  // 				"cardNumber": this.form2.value?.paymentSource?.cardNumber,
  // 				"cardSecurityCode": this.form2.value?.paymentSource?.cardSecurityCode != null ? this.form2.value?.paymentSource?.cardSecurityCode.toString() : '',
  // 				"cardExpirationYear": this.form2.value?.paymentSource?.cardExpirationYear,
  // 				"cardExpirationMonth": this.form2.value?.paymentSource?.cardExpirationMonth,
  // 				"stateOrProvince": this.reservation?.guestProfile?.adrState,
  // 				"postalCode": this.form2.value?.paymentSource?.postalCode,
  // 				"zip": this.form2.value?.paymentSource?.postalCode,
  // 				"city": this.reservation?.guestProfile?.adrCity,
  // 				"countryName": this.reservation?.guestProfile?.adrCountry,
  // 				"stateName": this.reservation?.guestProfile?.adrState,
  // 				"email": this.reservation?.guestProfile?.emailAddress,
  // 				"phone": this.reservation?.guestProfile?.mobilePhone,
  // 				"addressLine1": this.reservation?.guestProfile?.adrStreet,
  // 				"paymentTypeId": 1,
  // 				"cardName": this.form2.value?.paymentSource?.cardName,
  // 				"creditCardTypeId": 1,
  // 				"paymentDescription": "XXX",
  // 				"cardType": "VISA",
  // 				"country": "US",
  // 				"paymentType": "CR",
  // 				"iAgree": this.form2.value.paymentSource.iAgree == true ? "Yes" : "No",
  // 				"paymentSourceId": this.form2.value.paymentSource?.paymentSourceId,
  // 				"transactionType": this.form2.value.paymentSource?.paymentCreditCardRequestedTransactionType,
  // 			},
  // 			"contract": {
  // 				"signName": "KBm KBmresorts null",
  // 				"signEmail": "dev@kbmresorts.cpm"
  // 			},
  // 		}
  // 		// call api related create booking
  // 		this.reservationService.makeAdditionalPaymentByAdmin(paymentData)
  // 			.subscribe(
  // 				(res: any) => {
  // 					this.formLoading = false;
  // 					this.visible = false;
  // 					if(res.data?.reservationSummary?.reservationApiList[0]?.status == "INVALID"){
  // 						this.confirmationService.confirm({
  // 							header: 'Payment Error',
  // 							message: res.data?.reservationSummary?.reservationApiList[0]?.errors[0]?.message,
  // 							icon: 'fa fa-exclamation-triangle',
  // 							rejectVisible: false,
  // 							acceptLabel: 'Close',
  // 							accept: () => {
  // 								//Actual logic to perform a confirmation
  // 								this.disabledBookReservationButton = false;
  // 								this.formLoading = false;
  // 							}
  // 						});
  // 					}else{
  // 						this.showPaymentSuccess = true;
  // 					}
  // 				},
  // 				(err: any) => {
  // 					this.disabledBookReservationButton = false;
  // 					this.formLoading = false;
  // 					this.confirmationService.confirm({
  // 						header: 'Payment Error',
  // 						message: err,
  // 						icon: 'fa fa-exclamation-triangle',
  // 						rejectVisible: false,
  // 						acceptLabel: 'Close',
  // 						accept: () => {
  // 							//Actual logic to perform a confirmation
  // 						}
  // 					});

  // 					console.log('property-add FAIL: ' + JSON.stringify(err));
  // 				},
  // 				() => { });
  // 	} catch (error) {
  // 		this.formLoading = false;
  // 	}
  // }

  //Close open dialog box
  closePaymentDialog() {
    this.showPaymentSuccess = false;
    window.location.reload();
  }

  // Checked mark i agree button
  checkedIAgree(event: any, validationName: any) {
    // clear signature pad

    // Set toggle like I agree by user checked or not
    // this.isGuestAgreeForCreditCard = event.target.checked;
    console.log("gggggg :" + event.target.checked);
    this.form2.value.paymentSource.iAgree = event.target.checked;
    if (event.target.checked) {
      this.isGuestAgreeForCreditCard = false;
      console.log("yyyyyyy :" + event.target.checked);
      // if (validationName == "iAgree" && this.errorList.indexOf(this.guestContractApproveMsg) !== -1) {
      // 	this.updateValidation(this.guestContractApproveMsg);
      // }
    } else {
      this.isGuestAgreeForCreditCard = true;
      // this.errorList.push(this.guestContractApproveMsg);
      // this.errorMessages = "";
      // for (let i = 0; i < this.errorList.length; i++) {
      // 	this.errorMessages += this.errorList[i] + "<br>";
      // }
    }

  }

  selectPaymentSource(event: any) {
    if (event?.value) {
      const paymentSource = this.paymentSources.find((e: any) => e.value == event.value);
      this.form2.get('paymentSource')?.get('cardName').setValue(paymentSource?.paymentSource?.billingName);
      this.form2.get('paymentSource')?.get('cardExpirationMonth').setValue(paymentSource?.paymentSource?.creditCardExpirationMonth);
      this.form2.get('paymentSource')?.get('cardExpirationYear').setValue(paymentSource?.paymentSource?.creditCardExpirationYear);
      this.form2.get('paymentSource')?.get('cardNumber').setValue(paymentSource?.paymentSource?.creditCardNumber);
      if(paymentSource?.paymentSource?.creditCardSecurityCode != null && paymentSource?.paymentSource?.creditCardSecurityCode != undefined && paymentSource?.paymentSource?.creditCardSecurityCode != ""){
        this.form2.get('paymentSource')?.get('cardSecurityCode').setValue(paymentSource?.paymentSource?.creditCardSecurityCode.toString());
      }
      this.form2.get('paymentSource')?.get('postalCode').setValue(paymentSource?.paymentSource?.billingPostalCode);
    }
    else {
      return '';
    }
  }


  getWorkOrderStatus(workOrder: any) {
    if (workOrder?.workOrderStatus) {
      const status = this.workOrderStatuses.find((e: any) => e.value == workOrder.workOrderStatus);
      return status.name;
    }
    else {
      return '-';
    }
  }

  getReservationStatus(reservationStatus: any) {
    if (reservationStatus) {
      const status = this.reservationStatuses.find((e: any) => e.value == reservationStatus);
      return status.name;
    }
    else {
      return '-';
    }
  }

  getReservationStatusColor(reservationStatus: any): string {
    if (reservationStatus) {
      const status = this.reservationStatuses.find((e: any) => e.value == reservationStatus);
      return status?.color || 'maroon';
    }
    return 'maroon';
  }

  getReservationStatusFontColor(reservationStatus: any): string {
    if (reservationStatus) {
      const status = this.reservationStatuses.find((e: any) => e.value == reservationStatus);
      return status?.fontColor || 'white';
    }
    return 'white';
  }

  getWorkOrderType(workOrder: any) {
    if (workOrder?.housekeepingType) {
      const status = this.housekeepingTypes.find((e: any) => e.value == workOrder.housekeepingType);
      return status.name;
    }
    else {
      return '';
    }
  }

  //Update tag list in reservation to show in colored tags list
  updateTagModified(event)
  {
    this.reservation.tagJoinAPIS = event;
  }

  filterText(text: string) {
    if (text) {
      text = text
        .replace('<br>', '\r')
        .replace('/&lt;br/&gt;', '\r')
        .replace('</p>', '')
        .replace('<br>', '\r')
      // .replace(/(?:\r\n|\r|\n|\\r|\\n)/gi, '<br>');
      return text;
    }
    return '';
  }


  // Update CheckInCheckOut method
  updateCheckInCheckOut(){
    const formData = JSON.parse(JSON.stringify(this.form1.value));
    if (formData.checkInDate != "undefined" && formData.checkInDate != null) {
      if (formData.checkInDate.includes("T")) {
        formData.checkInDate = moment(formData.checkInDate).format("YYYY-MM-DD");
      } else {
        var splitDateOfCheckInDate = formData.checkInDate.split('/');
        if (splitDateOfCheckInDate[0].length == 2) {
          var monthOfCheckInDate = splitDateOfCheckInDate[0];
          var dayOfCheckInDate = splitDateOfCheckInDate[1];
          var yearOfCheckInDate = splitDateOfCheckInDate[2];
          formData.checkInDate = yearOfCheckInDate + "-" + monthOfCheckInDate + "-" + dayOfCheckInDate;
        }
        if (splitDateOfCheckInDate[0].length == 4) {
          var yearOfCheckInDate = splitDateOfCheckInDate[0];
          var monthOfCheckInDate = splitDateOfCheckInDate[1];
          var dayOfCheckInDate = splitDateOfCheckInDate[2];
          formData.checkInDate = yearOfCheckInDate + "-" + monthOfCheckInDate + "-" + dayOfCheckInDate;
        }
      }
    } else {
      formData.checkInDate = '';
    }
    if (formData.checkOutDate != "undefined" && formData.checkOutDate != null) {
      if (formData.checkOutDate.includes("T")) {
        formData.checkOutDate = moment(formData.checkOutDate).format("YYYY-MM-DD");
      } else {
        var splitDateOfCheckOutDate = formData.checkOutDate.split('/');
        if (splitDateOfCheckOutDate[0].length == 2) {
          var monthOfCheckOutDate = splitDateOfCheckOutDate[0];
          var dayOfCheckOutDate = splitDateOfCheckOutDate[1];
          var yearOfCheckOutDate = splitDateOfCheckOutDate[2];
          formData.checkOutDate = yearOfCheckOutDate + "-" + monthOfCheckOutDate + "-" + dayOfCheckOutDate;
        }
        if (splitDateOfCheckOutDate[0].length == 4) {
          var yearOfCheckOutDate = splitDateOfCheckOutDate[0];
          var monthOfCheckOutDate = splitDateOfCheckOutDate[1];
          var dayOfCheckOutDate = splitDateOfCheckOutDate[2];
          formData.checkOutDate = yearOfCheckOutDate + "-" + monthOfCheckOutDate + "-" + dayOfCheckOutDate;
        }
      }
    } else {
      formData.checkOutDate = '';
    }
    this.form1.value.checkInDate = formData.checkInDate;
    this.form1.value.checkOutDate = formData.checkOutDate;
    this.updateReservation();
  }


  // if select checkin date at that time checkout date set as null
  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
    // this.form1.patchValue({
    // 	checkOutDate: ""
    // });
  }

  // if select checkout date at that time check checkin date must be below lessthan one day of selected date
  onKeyDateForCheckOutDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
    if(this.form1.value.checkInDate){
      let today = new Date(this.form1.value.checkInDate);
      this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
      this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
    }
  }

  // compare checkin and checkout dates
  compareDate(date: any) {
    this.isDateLessThanCheckinDate = false;
    if (Date.parse(date.target.value) < Date.parse(moment(this.checkOutDateBasedOnCheckinDate).format("MM/DD/YYYY"))) {
      this.isDateLessThanCheckinDate = true;
    }
  }

  // open guest modal
  openGuestModal(e: any) {
    // this.dropdown.show();
  }

  // change checking date
  checkInChange(e: any) {
    let today = new Date(e.valueOf());
    this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
    this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
    this.isDisplayClearDates = true;
    // this.form1.patchValue({
    // 	checkOutDate: ""
    // });
    window.setTimeout(() => {
      this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
    }, 1);
  }

  // change checkout date
  checkOutChange(e: any) {
    this.isDisplayClearDates = true;
    this.updateReservation();
    // this.guestDropdownCount.show();
  }

  // For Update only reservation status
  updateReservationStatusAndAdult() {
    // stop here if form is invalid
    this.form1.markAllAsTouched();
    if (this.form1.invalid) {
      return;
    }
    // this.formLoading = true;
    this.reservation.order.status = this.form1.value.status;
    this.reservation.order.referralSourceId = this.form1.value.referralSourceId;
    this.reservation.ruReservationId = this.form1.value.ruReservationId;

    //=============================
    // creditSaleToUserId: [],
    // creditSaleToUser2Id: [],
    // salesTax: [],
    // tax: [] = this.form1.value.
    //=============================
    if(this.form1.value.premium === "0.0000%"){
      this.reservation.order.orderInvoice.ccPremiumPct = this.reservation.order.orderInvoice.ccPremiumPct;
    }else{
      this.reservation.order.orderInvoice.ccPremiumPct = this.form1.value.premium;
    }
    this.reservation.reservationStatus = this.form1.value.reservationStatus;
    this.reservation.numAdults = this.form1.value.numAdults;
    this.reservation.numChildren = this.form1.value.numChildren;
    this.reservation.airportArrivalDate = this.form1.value.airportArrivalDate;
    this.reservation.airportDepartureDate = this.form1.value.airportDepartureDate;

    this.reservation.earlyCheckinDate = this.form1.value.earlyCheckinDate;
    this.reservation.lateCheckoutDate = this.form1.value.lateCheckoutDate;

    //===============================
    // arrivalHour1: [] = this.form1.value.
    // arrivalMinute1: [] = this.form1.value.
    // arrivalAmPm1: [] = this.form1.value.
    //===================================

    this.reservation.arrivingAirlineName = this.form1.value.arrivingAirlineName;
    this.reservation.arrivingAirlineFlightNum = this.form1.value.arrivingAirlineFlightNum;

    //=============================
    // arrivalHour2: [] = this.form1.value.
    // arrivalMinute2: [] = this.form1.value.
    // arrivalAmPm2: [] = this.form1.value.
    //===============================


    this.reservation.departingAirlineName = this.form1.value.departingAirlineName;
    this.reservation.departingAirlineFlightNum = this.form1.value.departingAirlineFlightNum;

    //==============================
    // propertyArrivalHour1: [] = this.form1.value.
    // propertyArrivalMinute1: [] = this.form1.value.
    // propertyArrivalAmPm1: [] = this.form1.value.
    // propertyArrivalHour2: [] = this.form1.value.
    // propertyArrivalMinute2: [] = this.form1.value.
    // propertyArrivalAmPm2: [] = this.form1.value.
    //=======================================

    this.reservation.checkOutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkOutDate));
    this.reservation.checkInDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkInDate));

    //=====================================
    // specialArrivalHour: [] = this.form1.value.
    // specialArrivalMinute: [] = this.form1.value.
    // specialArrivalAmPm: [] = this.form1.value.
    // specialDepartingHour: [] = this.form1.value.
    // specialDepartingMinute: [] = this.form1.value.
    // specialDepartingAmPm: [] = this.form1.value.
    //====================================

    this.reservation.guestNotes = this.form1.value.guestNotes;
    this.reservation.opsNotes = this.form1.value.opsNotes;
    // lostFoundId: [] = this.form1.value.
    this.reservation.keyServiceType = this.form1.value.keyServiceType;
    this.reservation.codeFrontDoor = this.form1.value.codeFrontDoor;
    this.reservation.codeGarage = this.form1.value.codeGarage;
    this.reservation.towelCode = this.form1.value.towelCode,
      this.reservation.codeGate = this.form1.value.codeGate;
    this.reservation.codeHoaGate = this.form1.value.codeHoaGate;
    this.reservation.rentalCarBudget = this.form1.value.rentalCarBudget;
    this.reservation.rentalCarAvis = this.form1.value.rentalCarAvis;
    this.reservation.codePool = this.form1.value.codePool;
    this.reservation.codeRecreation = this.form1.value.codeRecreation;
    this.reservation.primaryMobilePhone = this.form1.value.guestProfile.primaryMobilePhone;
    this.reservation.specialRequests = this.form1.value.specialRequests;
    // this.reservation.earlyCheckinDate = this.reservation.earlyCheckinDate;
    // this.reservation.lateCheckoutDate = this.reservation.lateCheckoutDate;

    if(this.reservation.guestProfile != null && this.reservation.guestProfile != undefined){
      this.reservation.guestProfile.firstName = this.form1.value.guestProfile.firstName;
      this.reservation.guestProfile.lastName = this.form1.value.guestProfile.lastName;
      this.reservation.guestProfile.title = this.form1.value.guestProfile.title;
      this.reservation.guestProfile.emailAddress = this.form1.value.guestProfile.emailAddress;
      this.reservation.guestProfile.mobilePhone = this.form1.value.guestProfile.mobilePhone;
      this.reservation.guestProfile.adrPhone = this.form1.value.guestProfile.adrPhone;
      this.reservation.guestProfile.adrStreet = this.form1.value.guestProfile.adrStreet;
      this.reservation.guestProfile.adrCity = this.form1.value.guestProfile.adrCity;
      this.reservation.guestProfile.adrState = this.form1.value.guestProfile.adrState;
      this.reservation.guestProfile.adrPostalCode = this.form1.value.guestProfile.adrPostalCode;
      this.reservation.guestProfile.adrCountry = this.form1.value.guestProfile.adrCountry;
      this.reservation.guestProfile.emergencyContactNotes = this.form1.value.guestProfile.emergencyContactNotes;
      this.reservation.guestProfile.travelOccasionNotes = this.form1.value.guestProfile.travelOccasionNotes;
      this.reservation.guestProfile.travelOccasion = this.form1.value.guestProfile.travelOccasion;
    }
    // if(this.guestCompanions.length > 0){
    this.reservation.guestProfile.guestCompanions =  this.form1.value.guestProfile.guestCompanions;
    // }

    if(this.reservation.order.orderInvoice.paymentSourceDeposit == null || this.reservation.order.orderInvoice.paymentSourceDeposit == undefined){
      const paymentData = {
        billingName: "",
        billingStreetAddress: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: "",
        billingCountry: "",
        creditCardNumber: "",
        creditCardExpirationMonth: "",
        creditCardExpirationYear: "",
        creditCardSecurityCode: "",
        paymentType: "",
        achBankName: "",
        achBankAccountNumber: "",
        achRoutingNumber: "",
        achCheckNumber: "",
        achMicrData: "",
        achBranchSortCode: "",
      }
      this.reservation.order.orderInvoice.paymentSourceDeposit = paymentData;
    }


    this.reservation.order.orderInvoice.paymentSourceDeposit.billingName = this.form1.value.paymentSourceDeposit.billingName;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingStreetAddress = this.form1.value.paymentSourceDeposit.billingStreetAddress;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingCity = this.form1.value.paymentSourceDeposit.billingCity;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingState = this.form1.value.paymentSourceDeposit.billingState;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingPostalCode = this.form1.value.paymentSourceDeposit.billingPostalCode;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingCountry = this.form1.value.paymentSourceDeposit.billingCountry;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardNumber = this.form1.value.paymentSourceDeposit.creditCardNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationMonth = this.form1.value.paymentSourceDeposit.creditCardExpirationMonth;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationYear = this.form1.value.paymentSourceDeposit.creditCardExpirationYear;
    if(this.form1.value.paymentSourceDeposit.creditCardSecurityCode != null && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != undefined && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != ""){
      this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardSecurityCode = this.form1.value.paymentSourceDeposit.creditCardSecurityCode.toString();
    }
    this.reservation.order.orderInvoice.paymentSourceDeposit.paymentType = this.form1.value.paymentSourceDeposit.paymentType;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBankName = this.form1.value.paymentSourceDeposit.achBankName;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBankAccountNumber = this.form1.value.paymentSourceDeposit.achBankAccountNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achRoutingNumber = this.form1.value.paymentSourceDeposit.achRoutingNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achCheckNumber = this.form1.value.paymentSourceDeposit.achCheckNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achMicrData = this.form1.value.paymentSourceDeposit.achMicrData;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBranchSortCode = this.form1.value.paymentSourceDeposit.achBranchSortCode;


    if(this.reservation.order.orderInvoice.paymentSourceFunding == null || this.reservation.order.orderInvoice.paymentSourceFunding == undefined){
      const paymentData = {
        billingName: "",
        billingStreetAddress: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: "",
        billingCountry: "",
        creditCardNumber: "",
        creditCardExpirationMonth: "",
        creditCardExpirationYear: "",
        creditCardSecurityCode: "",
        paymentType: "",
        achBankName: "",
        achBankAccountNumber: "",
        achRoutingNumber: "",
        achCheckNumber: "",
        achMicrData: "",
        achBranchSortCode: "",
      }
      this.reservation.order.orderInvoice.paymentSourceFunding = paymentData;
    }

    this.reservation.order.orderInvoice.paymentSourceFunding.billingName = this.form1.value.paymentSourceFunding.billingName;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingStreetAddress = this.form1.value.paymentSourceFunding.billingStreetAddress;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingCity = this.form1.value.paymentSourceFunding.billingCity;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingState = this.form1.value.paymentSourceFunding.billingState;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingPostalCode = this.form1.value.paymentSourceFunding.billingPostalCode;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingCountry = this.form1.value.paymentSourceFunding.billingCountry;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardNumber = this.form1.value.paymentSourceFunding.creditCardNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationMonth = this.form1.value.paymentSourceFunding.creditCardExpirationMonth;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationYear = this.form1.value.paymentSourceFunding.creditCardExpirationYear;
    if(this.form1.value.paymentSourceFunding.creditCardSecurityCode != null && this.form1.value.paymentSourceFunding.creditCardSecurityCode != undefined && this.form1.value.paymentSourceFunding.creditCardSecurityCode != ""){
      this.reservation.order.orderInvoice.paymentSourceFunding.creditCardSecurityCode = this.form1.value.paymentSourceFunding.creditCardSecurityCode.toString();
    }
    this.reservation.order.orderInvoice.paymentSourceFunding.paymentType = this.form1.value.paymentSourceFunding.paymentType;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBankName = this.form1.value.paymentSourceFunding.achBankName;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBankAccountNumber = this.form1.value.paymentSourceFunding.achBankAccountNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achRoutingNumber = this.form1.value.paymentSourceFunding.achRoutingNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achCheckNumber = this.form1.value.paymentSourceFunding.achCheckNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achMicrData = this.form1.value.paymentSourceFunding.achMicrData;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBranchSortCode = this.form1.value.paymentSourceFunding.achBranchSortCode;
    this.reservation.reservationDirty = true;
    this.getReservations.emit(this.reservation);
    // this.alertService.error('Please enter a title first before entering any other fields.');
    this.formLoading = true;
    this.reservationService.updateGuestInfo(this.reservation)
      .pipe(first())
      .subscribe(
        res => {
          this.formLoading = false;
          console.log('findReservationById: ' + JSON.stringify(res));
          this.alertService.success("Reservation update successfully", true);
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Update reservation successfully', life: 1000 });
          // this.reservation = res.data.reservation;
          this.findReservationById();
        },
        err => {
          // Do NOT reset formLoading on error — a 504 means the reservation update may have
          // already persisted. Keep button disabled to block re-submit.
          console.log('updateGuestInfo FAIL: ' + JSON.stringify(err));
          this.alertService.error(err, true);
        },
        () => {  });
  }

  // Update adult and children
  updateReservationAdultAndChildren() {
    // stop here if form is invalid
    this.form1.markAllAsTouched();
    if (this.form1.invalid) {
      return;
    }
    // this.formLoading = true;
    this.reservation.order.status = this.form1.value.status;
    this.reservation.order.referralSourceId = this.form1.value.referralSourceId;
    this.reservation.ruReservationId = this.form1.value.ruReservationId;

    //=============================
    // creditSaleToUserId: [],
    // creditSaleToUser2Id: [],
    // salesTax: [],
    // tax: [] = this.form1.value.
    //=============================
    if(this.form1.value.premium === "0.0000%"){
      this.reservation.order.orderInvoice.ccPremiumPct = this.reservation.order.orderInvoice.ccPremiumPct;
    }else{
      this.reservation.order.orderInvoice.ccPremiumPct = this.form1.value.premium;
    }
    this.reservation.reservationStatus = this.form1.value.reservationStatus;
    this.reservation.numAdults = this.form1.value.numAdults;
    this.reservation.numChildren = this.form1.value.numChildren;
    this.reservation.airportArrivalDate = this.form1.value.airportArrivalDate;
    this.reservation.airportDepartureDate = this.form1.value.airportDepartureDate;

    this.reservation.earlyCheckinDate = this.form1.value.earlyCheckinDate;
    this.reservation.lateCheckoutDate = this.form1.value.lateCheckoutDate;

    //===============================
    // arrivalHour1: [] = this.form1.value.
    // arrivalMinute1: [] = this.form1.value.
    // arrivalAmPm1: [] = this.form1.value.
    //===================================

    this.reservation.arrivingAirlineName = this.form1.value.arrivingAirlineName;
    this.reservation.arrivingAirlineFlightNum = this.form1.value.arrivingAirlineFlightNum;

    //=============================
    // arrivalHour2: [] = this.form1.value.
    // arrivalMinute2: [] = this.form1.value.
    // arrivalAmPm2: [] = this.form1.value.
    //===============================


    this.reservation.departingAirlineName = this.form1.value.departingAirlineName;
    this.reservation.departingAirlineFlightNum = this.form1.value.departingAirlineFlightNum;

    //==============================
    // propertyArrivalHour1: [] = this.form1.value.
    // propertyArrivalMinute1: [] = this.form1.value.
    // propertyArrivalAmPm1: [] = this.form1.value.
    // propertyArrivalHour2: [] = this.form1.value.
    // propertyArrivalMinute2: [] = this.form1.value.
    // propertyArrivalAmPm2: [] = this.form1.value.
    //=======================================

    this.reservation.checkOutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkOutDate));
    this.reservation.checkInDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkInDate));

    //=====================================
    // specialArrivalHour: [] = this.form1.value.
    // specialArrivalMinute: [] = this.form1.value.
    // specialArrivalAmPm: [] = this.form1.value.
    // specialDepartingHour: [] = this.form1.value.
    // specialDepartingMinute: [] = this.form1.value.
    // specialDepartingAmPm: [] = this.form1.value.
    //====================================

    this.reservation.guestNotes = this.form1.value.guestNotes;
    this.reservation.opsNotes = this.form1.value.opsNotes;
    // lostFoundId: [] = this.form1.value.
    this.reservation.keyServiceType = this.form1.value.keyServiceType;
    this.reservation.codeFrontDoor = this.form1.value.codeFrontDoor;
    this.reservation.codeGarage = this.form1.value.codeGarage;
    this.reservation.towelCode = this.form1.value.towelCode,
      this.reservation.codeGate = this.form1.value.codeGate;
    this.reservation.codeHoaGate = this.form1.value.codeHoaGate;
    this.reservation.rentalCarBudget = this.form1.value.rentalCarBudget;
    this.reservation.rentalCarAvis = this.form1.value.rentalCarAvis;
    this.reservation.codePool = this.form1.value.codePool;
    this.reservation.codeRecreation = this.form1.value.codeRecreation;
    this.reservation.primaryMobilePhone = this.form1.value.guestProfile.primaryMobilePhone;
    this.reservation.specialRequests = this.form1.value.specialRequests;
    // this.reservation.earlyCheckinDate = this.reservation.earlyCheckinDate;
    // this.reservation.lateCheckoutDate = this.reservation.lateCheckoutDate;

    if(this.reservation.guestProfile != null && this.reservation.guestProfile != undefined){
      this.reservation.guestProfile.firstName = this.form1.value.guestProfile.firstName;
      this.reservation.guestProfile.lastName = this.form1.value.guestProfile.lastName;
      this.reservation.guestProfile.title = this.form1.value.guestProfile.title;
      this.reservation.guestProfile.emailAddress = this.form1.value.guestProfile.emailAddress;
      this.reservation.guestProfile.mobilePhone = this.form1.value.guestProfile.mobilePhone;
      this.reservation.guestProfile.adrPhone = this.form1.value.guestProfile.adrPhone;
      this.reservation.guestProfile.adrStreet = this.form1.value.guestProfile.adrStreet;
      this.reservation.guestProfile.adrCity = this.form1.value.guestProfile.adrCity;
      this.reservation.guestProfile.adrState = this.form1.value.guestProfile.adrState;
      this.reservation.guestProfile.adrPostalCode = this.form1.value.guestProfile.adrPostalCode;
      this.reservation.guestProfile.adrCountry = this.form1.value.guestProfile.adrCountry;
      this.reservation.guestProfile.emergencyContactNotes = this.form1.value.guestProfile.emergencyContactNotes;
      this.reservation.guestProfile.travelOccasionNotes = this.form1.value.guestProfile.travelOccasionNotes;
      this.reservation.guestProfile.travelOccasion = this.form1.value.guestProfile.travelOccasion;
    }
    // if(this.guestCompanions.length > 0){
    this.reservation.guestProfile.guestCompanions =  this.form1.value.guestProfile.guestCompanions;
    // }

    if(this.reservation.order.orderInvoice.paymentSourceDeposit == null || this.reservation.order.orderInvoice.paymentSourceDeposit == undefined){
      const paymentData = {
        billingName: "",
        billingStreetAddress: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: "",
        billingCountry: "",
        creditCardNumber: "",
        creditCardExpirationMonth: "",
        creditCardExpirationYear: "",
        creditCardSecurityCode: "",
        paymentType: "",
        achBankName: "",
        achBankAccountNumber: "",
        achRoutingNumber: "",
        achCheckNumber: "",
        achMicrData: "",
        achBranchSortCode: "",
      }
      this.reservation.order.orderInvoice.paymentSourceDeposit = paymentData;
    }


    this.reservation.order.orderInvoice.paymentSourceDeposit.billingName = this.form1.value.paymentSourceDeposit.billingName;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingStreetAddress = this.form1.value.paymentSourceDeposit.billingStreetAddress;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingCity = this.form1.value.paymentSourceDeposit.billingCity;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingState = this.form1.value.paymentSourceDeposit.billingState;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingPostalCode = this.form1.value.paymentSourceDeposit.billingPostalCode;
    this.reservation.order.orderInvoice.paymentSourceDeposit.billingCountry = this.form1.value.paymentSourceDeposit.billingCountry;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardNumber = this.form1.value.paymentSourceDeposit.creditCardNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationMonth = this.form1.value.paymentSourceDeposit.creditCardExpirationMonth;
    this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationYear = this.form1.value.paymentSourceDeposit.creditCardExpirationYear;
    if(this.form1.value.paymentSourceDeposit.creditCardSecurityCode != null && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != undefined && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != ""){
      this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardSecurityCode = this.form1.value.paymentSourceDeposit.creditCardSecurityCode.toString();
    }
    this.reservation.order.orderInvoice.paymentSourceDeposit.paymentType = this.form1.value.paymentSourceDeposit.paymentType;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBankName = this.form1.value.paymentSourceDeposit.achBankName;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBankAccountNumber = this.form1.value.paymentSourceDeposit.achBankAccountNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achRoutingNumber = this.form1.value.paymentSourceDeposit.achRoutingNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achCheckNumber = this.form1.value.paymentSourceDeposit.achCheckNumber;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achMicrData = this.form1.value.paymentSourceDeposit.achMicrData;
    this.reservation.order.orderInvoice.paymentSourceDeposit.achBranchSortCode = this.form1.value.paymentSourceDeposit.achBranchSortCode;


    if(this.reservation.order.orderInvoice.paymentSourceFunding == null || this.reservation.order.orderInvoice.paymentSourceFunding == undefined){
      const paymentData = {
        billingName: "",
        billingStreetAddress: "",
        billingCity: "",
        billingState: "",
        billingPostalCode: "",
        billingCountry: "",
        creditCardNumber: "",
        creditCardExpirationMonth: "",
        creditCardExpirationYear: "",
        creditCardSecurityCode: "",
        paymentType: "",
        achBankName: "",
        achBankAccountNumber: "",
        achRoutingNumber: "",
        achCheckNumber: "",
        achMicrData: "",
        achBranchSortCode: "",
      }
      this.reservation.order.orderInvoice.paymentSourceFunding = paymentData;
    }

    this.reservation.order.orderInvoice.paymentSourceFunding.billingName = this.form1.value.paymentSourceFunding.billingName;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingStreetAddress = this.form1.value.paymentSourceFunding.billingStreetAddress;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingCity = this.form1.value.paymentSourceFunding.billingCity;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingState = this.form1.value.paymentSourceFunding.billingState;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingPostalCode = this.form1.value.paymentSourceFunding.billingPostalCode;
    this.reservation.order.orderInvoice.paymentSourceFunding.billingCountry = this.form1.value.paymentSourceFunding.billingCountry;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardNumber = this.form1.value.paymentSourceFunding.creditCardNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationMonth = this.form1.value.paymentSourceFunding.creditCardExpirationMonth;
    this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationYear = this.form1.value.paymentSourceFunding.creditCardExpirationYear;
    if(this.form1.value.paymentSourceFunding.creditCardSecurityCode != null && this.form1.value.paymentSourceFunding.creditCardSecurityCode != undefined && this.form1.value.paymentSourceFunding.creditCardSecurityCode != ""){
      this.reservation.order.orderInvoice.paymentSourceFunding.creditCardSecurityCode = this.form1.value.paymentSourceFunding.creditCardSecurityCode.toString();
    }
    this.reservation.order.orderInvoice.paymentSourceFunding.paymentType = this.form1.value.paymentSourceFunding.paymentType;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBankName = this.form1.value.paymentSourceFunding.achBankName;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBankAccountNumber = this.form1.value.paymentSourceFunding.achBankAccountNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achRoutingNumber = this.form1.value.paymentSourceFunding.achRoutingNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achCheckNumber = this.form1.value.paymentSourceFunding.achCheckNumber;
    this.reservation.order.orderInvoice.paymentSourceFunding.achMicrData = this.form1.value.paymentSourceFunding.achMicrData;
    this.reservation.order.orderInvoice.paymentSourceFunding.achBranchSortCode = this.form1.value.paymentSourceFunding.achBranchSortCode;
    this.reservation.reservationDirty = true;
    this.getReservations.emit(this.reservation);
    // this.alertService.error('Please enter a title first before entering any other fields.');
    this.formLoading = true;
    this.reservationService.updateGuestInfoAutoUpdate(this.reservation)
      .pipe(first())
      .subscribe(
        res => {
          this.formLoading = false;
          console.log('findReservationById: ' + JSON.stringify(res));
          this.alertService.success("Reservation update successfully", true);
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Update reservation successfully', life: 1000 });
          // this.reservation = res.data.reservation;
          this.findReservationById();
        },
        err => {
          // Do NOT reset formLoading on error — a 504 means the reservation update may have
          // already persisted. Keep button disabled to block re-submit.
          console.log('updateGuestInfoAutoUpdate FAIL: ' + JSON.stringify(err));
          this.alertService.error(err, true);
        },
        () => {  });
  }

  /**
   * Add time plus local time GMT hours as http request change time to UTC time
   * @param datetime
   * @returns
   */
  addLocalTimeToDateTime(datetime) {
    return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
  }

  doRefreshOrder(){
    this.refreshOrder.emit();
  }

doReGenerateOrder(){
    this.reGenerateOrder.emit();
  }

  autoResizeTextArea(textArea: HTMLTextAreaElement): void {
    textArea.style.height = '30px';  // Set default height
    if (textArea.scrollHeight > 30) {  // Only expand if content exceeds 30px
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  }

  /*********
   * Edit Button
   *
   */
  onOpenAdditionalPaymentPopUp() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "40vw";
    dialogConfig.width = "30vw";
    dialogConfig.disableClose = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Payment',
      reservation : this.reservation,
      paymentSources : this.paymentSources
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(AdditionalPaymentComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // close the dialogBox
        dialogRef.close();
      });
  }

  /*********
		* Edit Button
		*
		*/
	onOpenFormEditOwnerStmtExp(ownerStmtExp: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerStmtExp: ownerStmtExp,
			title: 'Edit OwnerStmtExp'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtExpComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
        window.location.reload();
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateOwnerStmtExpCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);
        window.location.reload();
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deleteOwnerStmtExpCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

  /*********
      * Edit Button
      *
      */
    onOpenExpenseFormEdit(expense: Expense) {
      const dialogConfig = new MatDialogConfig();
  
      // settings
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      dialogConfig.maxWidth = '60vw';
        dialogConfig.width = '40vw';
  
      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        expense: expense,
        title: 'Edit Expense'
      };
  
      // open the popup and get a reference to it called dialogRef
      const dialogRef = this.dialog.open(ExpenseComponent, dialogConfig);
  
      // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
      dialogRef.componentInstance.doUpdate.subscribe(
        data => {
          console.log('Dialog output:', data);
          this.doReGenerateOrder();
          // close the dialogBox
          dialogRef.close();
        });
  
      dialogRef.componentInstance.doDelete.subscribe(
        data => {
          console.log('Dialog output:', data);
  
          // close the dialogBox
          dialogRef.close();
        });
    }

    findById(expense: any) {
		try {
			this.formLoading = true;
			this.expenseService.findById(expense?.expenseId)
				.subscribe(
					(res: any) => {
            this.formLoading = false;
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.onOpenExpenseFormEdit(res.data.expense);
					},
					(err: any) => {
            this.formLoading = false;
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
      this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  /*********
       * View Reservation Ledger
       *
       */
    viewReservationLedger(reservation: any) {
  
      const dialogConfig = new MatDialogConfig();
  
      // settings
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      dialogConfig.maxWidth = "95vw";
      dialogConfig.width = "95vw";
      dialogConfig.maxHeight = "87vh";
      dialogConfig.height = "87vh";
  
      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        title: 'Reservation Ledgers',
        showFilter: true,
        showPagination: false,
        displayClose: false,
        isPopup: true,
        reservationId: reservation?.reservationId
      };
      // open the popup and get a reference to it called dialogRef
      const dialogRef = this.dialog.open(ReservationLedgerListComponent, dialogConfig);
  
      // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
      // dialogRef.componentInstance.doAdd.subscribe(
      // 	data => {
      // 		console.log('Dialog output:', data);
  
      // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      // 		this.addOrderDetailCB(data);
  
      // 		// close the dialogBox
      // 		dialogRef.close();
      // 	});
  }
  
  viewReservation(reservation: any) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/order', reservation?.order?.orderId])
    );
    window.open(url, '_blank');
  }
}
